import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "reactstrap";
import useOnClickOutside from "src/app/shared/hooks/useOnClickOutside";
import "./CloseChatDialog.css";
import { ICloseChatProps, CLOSE_CHAT_TYPES } from "./~types/CloseChatProps";

const CloseChatDialog = (props: ICloseChatProps) => {
    const { t } = useTranslation();
    const [selectedCloseType, setSelectedCloseType] = useState<CLOSE_CHAT_TYPES>(
        CLOSE_CHAT_TYPES.CLOSE_DEFAULT
    );
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleDropdownKeyUp = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Escape") {
            props.onClose();
        }
    };

    const handleConfirmClose = () => {
        const silently = selectedCloseType === CLOSE_CHAT_TYPES.CLOSE_SILENTLY;
        props.onClose();
        props.closeChat(props.selectedChatId, true, silently);
    };

    const handleConfirmCloseKeyUp = (e: React.KeyboardEvent<HTMLButtonElement>) =>
    {
        if (e.key === "Enter") {
            handleConfirmClose();
        }
    };

    useOnClickOutside([dropdownRef], (event: MouseEvent) => {
        if (props.isOpened && !dropdownRef?.current?.contains(event.target as Node))
        {
            props.onClose();
        }
    });

    if (!props.isOpened) return null;

    return (
        <div ref={dropdownRef} className="close-chat-dialog__menu" onKeyUp={handleDropdownKeyUp}>
            <div className="close-chat-dialog__title"> {t("chat.closeChatTitle")} </div>
            <hr />
            <Input
                className="close-chat-dialog__select"
                type="select"
                value={selectedCloseType}
                tabIndex={0}
                autoFocus
                onChange={(e) =>
                    setSelectedCloseType(
                        e.currentTarget.value as CLOSE_CHAT_TYPES
                    )
                }
            >
                <option value={CLOSE_CHAT_TYPES.CLOSE_DEFAULT}> {t("chat.closeNormally")} </option>
                <option value={CLOSE_CHAT_TYPES.CLOSE_SILENTLY}>{t("chat.closeSilently")} </option>
            </Input>
            <div className="close-chat-dialog__footer">
                <hr />
                <Button className="close-chat-dialog__action-btn" onClick={handleConfirmClose} onKeyUp={handleConfirmCloseKeyUp}>
                    {t("chat.closeChat")}
                </Button>
            </div>
        </div>
    );
};

export default CloseChatDialog;